import React from 'react';
import { ReactComponent as BaicInfoIcon } from "../../../../../../assets/img/svg/Receipt.svg"
import { ReactComponent as LocationIcon } from "../../../../../../assets/img/svg/MapPinArea.svg"
import { ReactComponent as ContactIcon } from "../../../../../../assets/img/svg/PhoneList.svg"
import { ReactComponent as ThirdPartyIcon } from "../../../../../../assets/img/svg/Database.svg"
import { ReactComponent as FeatureIcon } from "../../../../../../assets/img/svg/Star.svg"
import { ReactComponent as ReceiptIcon } from "../../../../../../assets/img/svg/Scroll.svg"
import { ReactComponent as TaxIcon } from "../../../../../../assets/img/svg/MoneyWavy.svg"
import { ReactComponent as LogsIcon } from "../../../../../../assets/img/svg/HourglassSimpleHigh.svg"
import { ReactComponent as PaymentIcon } from "../../../../../../assets/img/svg/CreditCardGray.svg"
import { ReactComponent as ExamIcon } from "../../../../../../assets/img/svg/Notepad.svg"
import { ReactComponent as CSCIcon } from "../../../../../../assets/img/svg/ProjectorScreenChart.svg"

import { getDropdownValueById } from 'views/pages/manage/masters/schoolMaster/schoolInfo/constant';
import { maskEmail, maskPhoneNumber } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/paymentLink/utils';
export const menuItems = [
    { id: 1,key:'basicDetail', icon: <BaicInfoIcon/>, label: 'Basic information', desc:'Edit basic details of a business area' },
    { id: 2,key:'locationDetail', icon: <LocationIcon/>, label: 'Location Details', desc:'List of changes made' },
    { id: 3,key:'contactDetail', icon: <ContactIcon/>, label: 'Contact details', desc:'Set L1 and L2 grievances' },
    { id: 4,key:'sapDetail', icon: <ThirdPartyIcon/>, label: 'Third party mapping', desc:'Edit plant details and its address' },

    { id: 5,key:'paymentGateway', icon: <PaymentIcon/>, label: 'Payment Gateway', desc:'List of changes made' },
    //{ id: 10, icon: <ExamIcon/>, label: 'Exam Mapping', desc:'List of changes made' },
    { id: 6,key:'cscMapping', icon: <CSCIcon/>, label: 'CSC Mapping', desc:'Map career, stream, class and exam' },
    { id: 7,key:'featureSetup', icon: <FeatureIcon/>, label: 'Feature setup', desc:'Edit features like receipt and refund' },
    { id: 8, key:'receiptIndex', icon: <ReceiptIcon/>, label: 'Receipt index', desc:'Edit receipt tax codes' },
    { id: 9, key:'taxMapping', icon: <TaxIcon/>, label: 'Tax mapping', desc:'Set tax type or tax%' },
    { id: 10,key:'logs', icon: <LogsIcon/>, label: 'Logs', desc:'List of changes made' },
  ];

export const basicDetail = {
  mandatoryDetails: [
    { colKey: 'businessAreaKey', label: 'BU area key* ', colType: 'input', disabled: true, renderData: (val) => val },
    { colKey: 'groupCode', label: 'Group code*', colType: 'select', disabled: true, renderData: (val) => val },
    { colKey: 'companyCode', label: 'Company code*', colType: 'select', disabled: true, renderData: (val) => val },
    { colKey: 'businessUnitType', label: 'Bu area type*', colType: 'select', disabled: true, customHandleChange: (setForm,currentVal) => { setForm((val) => ({ ...val,...EMPTY_FRANCHISE_FORM})) } },
    { colKey: 'campusInstitution', label: 'Campus institution*', colType: 'select', disabled: false, renderData: (val) => val },
    { colKey: 'region', label: 'Region*', colType: 'select', disabled: false, isMulti: true, renderData: (val) => val },
    { colKey: 'businessAreaDispValue', label: 'Display Value*', colType: 'input', disabled: true, renderData: (val) => val },
    { colKey: 'currency', label: 'Currency*', colType: 'select', disabled: false, renderData: (val) => val },
    { colKey: 'stateCode', label: 'State code*', colType: 'select', disabled: false, renderData: (val) => val },
    { colKey: 'businessAreaDesc', label: 'Branch display name*', colType: 'input', disabled: false, maxLength:30, renderData: (val) => val },
    { colKey: 'acadOrg', label: 'Academic organisation*', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'effectiveDate', label: 'Effective Date*', colType: 'date', disabled: false, renderData: (val) => val },
    { colKey: 'status', label: 'Status*', colType: 'status', disabled: false, renderData: (val) => val },
    { colKey: 'testTypeIds', label: 'Study Centre', colType: 'select', isMulti: true, disabled: false, renderData: (val) => val },
  ],

  franchiseDetails: [
    { colKey: 'franchiseType', label: 'Type ', colType: 'select', disabled: false, renderData: (val) => val },
    { colKey: 'franchiseBusinessName', label: 'Business Name', colType: 'input', disabled: false, maxLength: 60, renderData: (val) => val },
    { colKey: 'franchiseRegisteredAddress', label: 'Business Registered Address', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'franchiseSubType', label: 'Sub-Type', colType: 'checkbox', disabled: false, renderData: (val) => val },
  ],
  otherDetails: [
    { colKey: 'jurisdiction', label: 'Jurisdiction ', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'serviceTaxRegistration', label: 'Service tax registration ', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'gstInNumber', label: 'GSTIN Number ', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'cinllpNumber', label: 'CIN/LLp Number ', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'tid', label: 'TID ', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'referenceId', label: 'Reference ID', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'buUrl', label: 'BU URL', colType: 'input', disabled: false, renderData: (val) => val },
    { colKey: 'buUrlName', label: 'BU URL Name', colType: 'input', disabled: false, renderData: (val) => val },
  ]
}
export const locationDetail = [
  { colKey: 'buildingName', label: 'Building Name* ', colType: 'input', disabled: false, maxLength: 50, renderData: (val) => val },
  { colKey: 'address1', label: 'Address1* ', colType: 'input', disabled: false, maxLength: 80, renderData: (val) => val },
  { colKey: 'address2', label: 'Address2* ', colType: 'input', disabled: false, maxLength: 80, renderData: (val) => val },
  { colKey: 'address3', label: 'Address3 ', colType: 'input', disabled: false, maxLength: 80, renderData: (val) => val },
  { colKey: 'address4', label: 'Address4 ', colType: 'input', disabled: false, maxLength: 80, renderData: (val) => val },
  { colKey: 'landmark', label: 'Landmark* ', colType: 'input', disabled: false, maxLength: 100, renderData: (val) => val },
  { colKey: 'pincode', label: 'Pincode* ', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'city', label: 'City ', colType: 'input', disabled: true, renderData: (val) => val },
  { colKey: 'district', label: 'District ', colType: 'input', disabled: true, renderData: (val) => val },
  { colKey: 'state', label: 'State ', colType: 'input', disabled: true, renderData: (val) => val },
  { colKey: 'country', label: 'Country ', colType: 'input', disabled: true, renderData: (val) => val },
  { colKey: 'googleMapLink', label: 'Google Map Link* ', colType: 'input', disabled: false, renderData: (val) => val },
  { colKey: 'latitude', label: 'Latitude* ', colType: 'input', disabled: false, maxLength: 10, renderData: (val) => val },
  { colKey: 'longitude', label: 'Longitude* ', colType: 'input', disabled: false, maxLength: 10, renderData: (val) => val },
  { colKey: 'locationHistory', label: 'Location History ', colType: 'dialoge', disabled: false, renderData: (val) => val },
]
export const FRANCHISE_EMAIL_COLUMN = { colKey: 'franchiseEmail', label: 'Franchise Email* ', colType: 'input', disabled: false };
export const contactDetail = {
  mandatoryDetail: [
    { colKey: 'id', label: 'Employee Id* ', colType: 'input', disabled: false,renderData:(val)=>val },
    { colKey: 'contactName', label: 'Contact Name* ', colType: 'input', disabled: false,renderData:(val)=>val },
    // { colKey: 'contactName', label: 'Address* ', colType: 'input', disabled: false },
    { colKey: 'emailId', label: 'Email Id* ', colType: 'input', disabled: false,renderData:(val)=> maskEmail(val) },
    { colKey: 'centerEmailId', label: 'Center Email ID* ', colType: 'input', disabled: false,renderData:(val)=> maskEmail(val) },
    { colKey: 'contactNumbers', label: 'Branch phone number*', colType: 'textArea', disabled: false,renderData:(val)=>maskPhoneNumber(val) },
    { colKey: 'urlAddress', label: 'URL Address* ', colType: 'input', disabled: false,renderData:(val)=>val },
    { colKey: 'startTime', label: 'Opening hours start time*', colType: 'time', disabled: false,renderData:(val)=>val },
    { colKey: 'endTime', label: 'Closing hours end time*', colType: 'time', disabled: false,renderData:(val)=>val },
    { colKey: 'weekOffDays', label: 'Week Off* ', colType: 'week',isMulti:true, disabled: false,renderData:(val)=>val },
    ],
    l1Grievance:[
      { colKey: 'roleName', label: 'Role name* ', colType: 'select', disabled: false,renderData:(val)=>val },
      { colKey: 'contactNumber', label: 'Contact number', colType: 'input', disabled: false,renderData:(val)=> maskPhoneNumber(val) },
      { colKey: 'emailId', label: 'Email ID', colType: 'input', disabled: false,renderData:(val)=>maskEmail(val) },
    ],
    l2Grievance:[
      { colKey: 'roleName', label: 'Role Name*', colType: 'select', disabled: false,renderData:(val)=>val },
      { colKey: 'contactNumber', label: 'Contact number', colType: 'input', disabled: false,renderData:(val)=> maskPhoneNumber(val) },
      { colKey: 'emailId', label: 'Email ID', colType: 'input', disabled: false,renderData:(val)=>maskEmail(val) },
    ],
    l3Grievance:[
      { colKey: 'roleName', label: 'Role Name*', colType: 'select', disabled: false,renderData:(val)=>val },
      { colKey: 'contactNumber', label: 'Contact number', colType: 'input', disabled: false,renderData:(val)=>maskPhoneNumber(val) },
      { colKey: 'emailId', label: 'Email ID', colType: 'input', disabled: false,renderData:(val)=>maskEmail(val) },
    ]

}

export const sapDetail = [
  { colKey: 'sapPlantId', label: 'Plant Id*', colType: 'input', disabled: false, renderData:(val)=>val },
  { colKey: 'sapBusinessArea', label: 'SAP bussiness area*', colType: 'input', disabled: false, renderData:(val)=>val },
  { colKey: 'sapDescription', label: 'Description* ', colType: 'input', disabled: false, renderData:(val)=>val },
  { colKey: 'businessPlaceCode', label: 'Business Place Code* ', colType: 'input', disabled: false, renderData:(val)=>val },
  { colKey: 'defermentBusinessArea', label: 'Deferment Business Area* ', colType: 'input', disabled: false, renderData:(val)=>val },
  // { colKey: 'gstInNumber', label: 'GSTIN Number* ', colType: 'input', disabled: false },
];


export const processRowList=(rowList=[], dropdown={})=> {// fieldKey in dropdown and rowObj should be same
    return rowList.map(row => {
        const processedRow = {};

    for (const key in row) {
      if (dropdown.hasOwnProperty(key)) {
        processedRow[key] = getDropdownValueById(dropdown?.[key], row[key]);
      } else {
        processedRow[key] = row[key];
      }
    }

    return processedRow;
  });
}
export const fieldMap = {
  basicDetail: [...basicDetail.mandatoryDetails, ...basicDetail.otherDetails],
  locationDetail: locationDetail,
  contactDetail: [
    ...contactDetail.mandatoryDetail,
    ...contactDetail.l1Grievance,
    ...contactDetail.l2Grievance,
    ...contactDetail.l3Grievance
  ],
  sapDetail: sapDetail
};

export const franchiseTypeDropdown = [
  { label: 'Company', value: 'Company' },
  { label: 'LLP', value: 'LLP' },
  { label: 'Partnership', value: 'Partnership' },
  { label: 'Sole Proprietorship', value: 'Sole Proprietorship' }
]

const EMPTY_FRANCHISE_FORM = {
  franchiseType: '',
  franchiseBusinessName: '',
  franchiseRegisteredAddress: '',
  franchiseSubType: ''

}

export const BU_TYPE_FRANCHISE_ACCESS=['franchise', 'subcontractor']
export const URL_REGEX = /^(https?|ftp):\/\/((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|localhost|(\d{1,3}\.){3}\d{1,3}|\[::1\])(:\d+)?(\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?$/i;

export const getStatusCount =(value)=>{

  let c=0
    
  const l=Object.values(value)
  l.forEach(val=>{
    if(val=='ACTIVE')
      c++;
  })
  console.log('value',c,value)
  return c.length==0?'Inactive' : l.length==c? 'All Active': `${c} Active`
}
export const tabFilledHandler=(setFilled,key, val)=>{
  setFilled((prev)=>({...prev,[key]:val}))
}

export function isValidCoordinatesInput(latStr, lngStr) {
  const lat = parseFloat(latStr);
  const lng = parseFloat(lngStr);
  
  if (isNaN(lat) || isNaN(lng)) return false;

  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
}


